import React, { Component } from 'react';

import './DatenSchutzPage.scss';

class DatenSchutzPage extends Component {
  render() {
    return (
      <article className="DatenSchutzPage">
        <div className="row">
          <header className="col-md-10 col-md-offset-1 text-center section-header">
            <h1>Datenschutzerklärung</h1>
          </header>
        </div>
        <div className="row ">
          <section className="col-md-10 col-md-offset-1">
            <h3 className="text-center">
              § 1 Information über die Erhebung personenbezogener Daten
            </h3>
            <p>
              <strong>(1)</strong> Im Folgenden informieren wir über die
              Erhebung personenbezogener Daten bei Nutzung unserer Website.
              Personenbezogene Daten sind alle Daten, die auf Sie persönlich
              beziehbar sind, z. B. Name, Adresse, E-Mail-Adressen,
              Nutzerverhalten.
            </p>
            <p>
              <strong>(2)</strong> Verantwortlicher gem. Art. 4 Abs. 7
              EU-Datenschutz-Grundverordnung (DS-GVO) ist
            </p>

            <p>
              <strong>Südstadt Leben e.V.</strong> <br />
              Lutherkirche <br />
              Martin Luther-Platz 2-4 <br />
              50677 Köln <br />
            </p>
            <p>
              <strong>Kontakt:</strong> <br />
              Telefon 0221 / 38 44 63<br />
              E-Mail lutherkirche@suedstadt-leben-koeln.de <br />
            </p>

            <p>
              <strong>(3)</strong> Bei Ihrer Kontaktaufnahme mit uns per E-Mail
              oder über ein Kontaktformular werden die von Ihnen mitgeteilten
              Daten (Ihre E-Mail-Adresse, ggf. Ihr Name und Ihre Telefonnummer)
              von uns gespeichert, um Ihre Fragen zu beantworten. Die in diesem
              Zusammenhang anfallenden Daten löschen wir, nachdem die
              Speicherung nicht mehr erforderlich ist, oder schränken die
              Verarbeitung ein, falls gesetzliche Aufbewahrungspflichten
              bestehen.
            </p>
          </section>

          <section className="col-md-10 col-md-offset-1">
            <h3 className="text-center">§ 2 Ihre Rechte</h3>
            <p>
              <strong>(1)</strong> Sie haben gegenüber uns folgende Rechte
              hinsichtlich der Sie betreffenden personenbezogenen Daten:
            </p>

            <div className="list-container">
              <ul>
                <li>Recht auf Auskunft,</li>
                <li>Recht auf Berichtigung oder Löschung,</li>
                <li>Recht auf Einschränkung der Verarbeitung,</li>
                <li>Recht auf Widerspruch gegen die Verarbeitung,</li>
                <li>Recht auf Datenübertragbarkeit.</li>
              </ul>
            </div>
            <p>
              <strong>(2)</strong> Sie haben zudem das Recht, sich bei der
              Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer
              personenbezogenen Daten durch uns zu beschweren.
            </p>
          </section>
          <section className="col-md-10 col-md-offset-1">
            <h3 className="text-center">
              § 3 Erhebung personenbezogener Daten bei Besuch unserer Website
            </h3>
            <p>
              <strong>(1)</strong> Bei der bloß informatorischen Nutzung der
              Website, also wenn Sie sich nicht registrieren oder uns
              anderweitig Informationen übermitteln, erheben wir nur die
              personenbezogenen Daten, die Ihr Browser an unseren Server
              übermittelt. Wenn Sie unsere Website betrachten möchten, erheben
              wir die folgenden Daten, die für uns technisch erforderlich sind,
              um Ihnen unsere Website anzuzeigen und die Stabilität und
              Sicherheit zu gewährleisten (Rechtsgrundlage ist Art. 6 Abs. 1
              S. 1 lit. f DS-GVO):
            </p>
            <div className="list-container">
              <ul>
                <li>IP-Adresse</li>
                <li>Datum und Uhrzeit der Anfrage</li>
                <li>Zeitzonendifferenz zur Greenwich Mean Time (GMT)</li>
                <li>Inhalt der Anforderung (konkrete Seite)</li>
                <li>Zugriffsstatus/HTTP-Statuscode</li>
                <li>jeweils übertragene Datenmenge</li>
                <li>Website, von der die Anforderung kommt</li>
                <li>Browser</li>
                <li>Betriebssystem und dessen Oberfläche</li>
                <li>Sprache und Version der Browsersoftware.</li>
              </ul>
            </div>

            <p>
              <strong>(2)</strong> Zusätzlich zu den zuvor genannten Daten
              werden bei Ihrer Nutzung unserer Website Cookies auf Ihrem Rechner
              gespeichert. Bei Cookies handelt es sich um kleine Textdateien,
              die auf Ihrer Festplatte dem von Ihnen verwendeten Browser
              zugeordnet gespeichert werden und durch welche der Stelle, die den
              Cookie setzt (hier durch uns), bestimmte Informationen zufließen.
              Cookies können keine Programme ausführen oder Viren auf Ihren
              Computer übertragen. Sie dienen dazu, das Internetangebot
              insgesamt nutzerfreundlicher und effektiver zu machen.
            </p>

            <p>
              <strong>(3)</strong> Einsatz von Cookies:
            </p>
            <p>
              <strong>a)</strong> Diese Website nutzt folgende Arten von
              Cookies, deren Umfang und Funktionsweise im Folgenden erläutert
              werden:
            </p>

            <div className="list-container">
              <ul>
                <li>Transiente Cookies (dazu b)</li>
                <li>Persistente Cookies (dazu c).</li>
              </ul>
            </div>

            <p>
              <strong>b)</strong> Transiente Cookies werden automatisiert
              gelöscht, wenn Sie den Browser schließen. Dazu zählen insbesondere
              die Session-Cookies. Diese speichern eine sogenannte Session-ID,
              mit welcher sich verschiedene Anfragen Ihres Browsers der
              gemeinsamen Sitzung zuordnen lassen. Dadurch kann Ihr Rechner
              wiedererkannt werden, wenn Sie auf unsere Website zurückkehren.
              Die Session-Cookies werden gelöscht, wenn Sie sich ausloggen oder
              den Browser schließen.
            </p>

            <p>
              <strong>c)</strong> Persistente Cookies werden automatisiert nach
              einer vorgegebenen Dauer gelöscht, die sich je nach Cookie
              unterscheiden kann. Sie können die Cookies in den
              Sicherheitseinstellungen Ihres Browsers jederzeit löschen.
            </p>

            <p>
              <strong>d)</strong> Sie können Ihre Browser-Einstellung
              entsprechend Ihren Wünschen konfigurieren und z. B. die Annahme
              von Third-Party-Cookies oder allen Cookies ablehnen. Wir weisen
              Sie darauf hin, dass Sie eventuell nicht alle Funktionen dieser
              Website nutzen können.
            </p>

            <p>
              <strong>e)</strong> Wir setzen Cookies ein, um Sie für
              Folgebesuche identifizieren zu können, falls Sie über einen
              Account bei uns verfügen. Andernfalls müssten Sie sich für jeden
              Besuch erneut einloggen.
            </p>

            <p>
              <strong>f)</strong> Die genutzten Flash-Cookies werden nicht durch
              Ihren Browser erfasst, sondern durch Ihr Flash-Plug-in. Weiterhin
              nutzen wir HTML5 storage objects, die auf Ihrem Endgerät abgelegt
              werden. Diese Objekte speichern die erforderlichen Daten
              unabhängig von Ihrem verwendeten Browser und haben kein
              automatisches Ablaufdatum. Wenn Sie keine Verarbeitung der
              Flash-Cookies wünschen, müssen Sie ein entsprechendes Add-On
              installieren, z. B. „Better Privacy“ für Mozilla Firefox{' '}
              <a
                href="https://addons.mozilla.org/de/firefox/addon/betterprivacy/"
                rel="noopener noreferrer"
                target="_blank"
              >
                (https://addons.mozilla.org/de/firefox/addon/betterprivacy/)
              </a>{' '}
              oder das Adobe-Flash-Killer-Cookie für Google Chrome. Die Nutzung
              von HTML5 storage objects können Sie verhindern, indem Sie in
              Ihrem Browser den privaten Modus einsetzen. Zudem empfehlen wir,
              regelmäßig Ihre Cookies und den Browser-Verlauf manuell zu
              löschen.
            </p>
          </section>

          <section className="col-md-10 col-md-offset-1">
            <h3 className="text-center">
              § 4 Weitere Funktionen und Angebote unserer Website{' '}
            </h3>

            <p>
              <strong>(1)</strong> Neben der rein informatorischen Nutzung
              unserer Website bieten wir die Teilnahme an unserer Spendenaktion
              an, die Sie bei Interesse nutzen können. Dazu müssen Sie in der
              Regel weitere personenbezogene Daten angeben, die wir zur
              Durchführung nutzen und für die die zuvor genannten Grundsätze zur
              Datenverarbeitung gelten.{' '}
            </p>

            <p>
              <strong>(2)</strong> Teilweise bedienen wir uns zur Verarbeitung
              Ihrer Daten externer Dienstleister. Diese wurden von uns
              sorgfältig ausgewählt und beauftragt, sind an unsere Weisungen
              gebunden und werden regelmäßig kontrolliert.{' '}
            </p>
          </section>

          <section className="col-md-10 col-md-offset-1">
            <h3 className="text-center">
              § 5 Widerspruch oder Widerruf gegen die Verarbeitung Ihrer Daten
            </h3>

            <p>
              <strong>(1)</strong> Falls Sie eine Einwilligung zur Verarbeitung
              Ihrer Daten erteilt haben, können Sie diese jederzeit widerrufen.
              Ein solcher Widerruf beeinflusst die Zulässigkeit der Verarbeitung
              Ihrer personenbezogenen Daten, nachdem Sie ihn gegenüber uns
              ausgesprochen haben.
            </p>

            <p>
              <strong>(2)</strong> Soweit wir die Verarbeitung Ihrer
              personenbezogenen Daten auf die Interessenabwägung stützen, können
              Sie Widerspruch gegen die Verarbeitung einlegen. Dies ist der
              Fall, wenn die Verarbeitung nicht zur Erfüllung eines Vertrags mit
              Ihnen erforderlich ist. Bei Ausübung eines solchen Widerspruchs
              bitten wir um Darlegung der Gründe, weshalb wir Ihre
              personenbezogenen Daten nicht wie von uns durchgeführt verarbeiten
              sollten. Im Falle Ihres begründeten Widerspruchs prüfen wir die
              Sachlage und werden entweder die Datenverarbeitung einstellen bzw.
              anpassen oder Ihnen unsere zwingenden schutzwürdigen Gründe
              aufzeigen, aufgrund derer wir die Verarbeitung fortführen.
            </p>
          </section>
        </div>
      </article>
    );
  }
}

export default DatenSchutzPage;



// WEBPACK FOOTER //
// ./src/Containers/Pages/DatenSchutzPage.js